// LIST
export const FETCH_WEBSITE = "app/Website/FETCH_WEBSITE";
export const FETCH_WEBSITE_SUCCESS = "app/Website/FETCH_WEBSITE_SUCCESS";
export const FETCH_WEBSITE_FAILURE = "app/Website/FETCH_WEBSITE_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/Website/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Website/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Website/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_WEBSITE = "app/Website/ADD_WEBSITE";
export const ADD_WEBSITE_SUCCESS = "app/Website/ADD_WEBSITE_SUCCESS";
export const ADD_WEBSITE_FAILURE = "app/Website/ADD_WEBSITE_FAILURE";

// EDIT
export const EDIT_WEBSITE = "app/Website/EDIT_WEBSITE";
export const EDIT_WEBSITE_SUCCESS = "app/Website/EDIT_WEBSITE_SUCCESS";
export const EDIT_WEBSITE_FAILURE = "app/Website/EDIT_WEBSITE_FAILURE";

// DELETE
export const DELETE_WEBSITE = "app/Website/DELETE_WEBSITE";
export const DELETE_WEBSITE_SUCCESS = "app/Website/DELETE_WEBSITE_SUCCESS";
export const DELETE_WEBSITE_FAILURE = "app/Website/DELETE_WEBSITE_FAILURE";

// ADD MODAL
export const OPEN_WEBSITE_ADD_MODAL = "app/Website/OPEN_WEBSITE_ADD_MODAL";
export const CLOSE_WEBSITE_ADD_MODAL = "app/Website/CLOSE_WEBSITE_ADD_MODAL";

// EDIT MODAL
export const OPEN_WEBSITE_EDIT_MODAL = "app/Website/OPEN_WEBSITE_EDIT_MODAL";
export const SET_EDIT_SUCCESS = "app/Website/SET_EDIT_SUCCESS";
export const SET_EDIT_FAILURE = "app/Website/SET_EDIT_FAILURE";
export const CLOSE_WEBSITE_EDIT_MODAL = "app/Website/CLOSE_WEBSITE_EDIT_MODAL";
